'use client';

import { useState, useCallback, useRef } from 'react';
import PanelEditor from './PanelEditor';
import SemanticSidebar, { SimilarEntry } from './SemanticSidebar';
import { getSemanticMatches } from '@/lib/actions';

interface Panel {
  id: number;
  scene_id: number;
  order_index: number;
  title?: string | null;
  content?: string | null;
  image_path?: string | null;
}

interface Props {
  panels: Panel[];
  sceneId: string;
  arcId: string;
}

export default function StoryboardWorkspace({ panels, sceneId, arcId }: Props) {
  const [semanticResults, setSemanticResults] = useState<SimilarEntry[]>([]);
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleTextChange = useCallback((text: string) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      if (text.trim().length > 10) {
        try {
          const results = await getSemanticMatches(text);
          setSemanticResults(results as SimilarEntry[]);
        } catch {}
      }
    }, 500);
  }, []);

  return (
    <div className="flex gap-6 h-full overflow-hidden">
      <div className="flex-1 overflow-y-auto pr-1">
        <PanelEditor
          panels={panels}
          sceneId={sceneId}
          arcId={arcId}
          onTextChange={handleTextChange}
        />
      </div>
      <div className="overflow-y-auto">
        <SemanticSidebar results={semanticResults} />
      </div>
    </div>
  );
}
